import { Heading } from 'tiptap-extensions';
import { v4 as uuidv4 } from 'uuid';

export default class CustomHeading extends Heading {
	get schema() {
		return {
			attrs: {
				level: {
					default: 1,
				},
				id: {
					default: ''
				}
			},
			content: 'inline*',
			group: 'block',
			defining: true,
			draggable: false,
			parseDOM: this.options.levels
				.map(level => ({
					tag: `h${level}`,
					getAttrs: dom => ({
						level: level,
						id: dom.getAttribute('id')
					})
				})),
			toDOM: node => [`h${node.attrs.level}`, {
				id: node.attrs.id || this.createId()
			}, 0],
		}
	}

	createId() {
		return uuidv4();
	}
}